import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import isArray from 'lodash/isArray';
import { localizeDate as _localizeDate, readableFileSizeFromBytes as _readableFileSizeFromBytes } from '../../../utils/vuex';
import get from 'lodash/get';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
var techSpecKeys = ['Model', 'Usage', 'Configuration', 'Connectivity', 'Frequency', 'TX Power', 'TX Distance', 'Power Supply', 'Operating Temperature', 'Security', 'Mounting', 'Dimensions', 'Weight', 'Standard', 'Battery', 'Battery Life', 'Firmware', 'Precision', 'Installation Height', 'Other'];
export default {
  name: 'NiotaClassicDevicetypesDetails',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  props: {
    deviceTypeId: {
      type: String,
      required: true
    },
    deviceTypeData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      techSpecKeys: techSpecKeys,
      formDialog: false,
      editedItem: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    deviceName: function deviceName() {
      return get(this.deviceTypeData, 'properties.manufacturer.device_name');
    }
  }),
  watch: {
    deviceTypeData: function deviceTypeData() {
      if (!this.deviceTypeData.properties) {
        this.deviceTypeData.properties = {};
      }

      if (!this.deviceTypeData.properties.manufacturer) {
        this.deviceTypeData.properties.manufacturer = {};
      }

      if (!isArray(this.deviceTypeData.properties.manufacturer.device_manual_file)) {
        if (this.deviceTypeData.properties.manufacturer.device_manual_file && this.deviceTypeData.properties.manufacturer.device_manual_file.constructor === Object) {
          this.deviceTypeData.properties.manufacturer.device_manual_file = [this.deviceTypeData.properties.manufacturer.device_manual_file];
        }
      }

      if (!this.deviceTypeData.properties.technical_specs) {
        this.deviceTypeData.properties.technical_specs = {};
      }
    }
  },
  methods: {
    clickManufacturerFile: function clickManufacturerFile(file) {
      window.open(this.getManualFileUrl(file.storagePath));
    },
    readableFileSizeFromBytes: function readableFileSizeFromBytes(fileSize) {
      return _readableFileSizeFromBytes(fileSize);
    },
    localizeDate: function localizeDate(date) {
      return _localizeDate(date);
    },
    getManualFileUrl: function getManualFileUrl(image) {
      if (/^http(?:s):\/\//i.test(image)) {
        return image;
      }

      return "".concat(process.env.VUE_APP_N1_API_PROTOCOL, "://").concat(process.env.VUE_APP_N1_API_HOST).concat(image);
    }
  }
};